import { useQueryGetAllUiPreferences } from "@apis:ui_preferences/ui_preferences";
import { useUser } from "@libs:react-query-auth";
import { useMemo } from "react";

type UserPreference = {
  autoTitleEnabled?: boolean | null;
};

export const useCheckAutoTitle = () => {
  const user = useUser().data;
  const userId = user?.id;

  const { data: uiPreferences, isLoading } = useQueryGetAllUiPreferences(
    true,
    userId,
    undefined,
    {
      enabled: !!userId,
    },
  );

  const isAutoTitleEnabled = useMemo(() => {
    if (!uiPreferences || !userId) return false;

    const userPreference = uiPreferences.find(
      (pref) => pref.userId === userId && !pref.botId,
    );

    // The backend generates titles unless the preference is explicitly disabled
    return (
      (userPreference?.preference as UserPreference)?.autoTitleEnabled !== false
    );
  }, [uiPreferences, userId]);

  return {
    isAutoTitleEnabled,
    isLoading,
  };
};
